import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreatePerDiemPolicy } from "../api/queries";
import { PerDiemPolicyForm } from "../ui/PerDiemPolicyForm";

export function PerDiemPolicyCreatePage() {
  const nav = useNavigate({ from: "/app/performance/per-diem/create" });
  const createPolicy = useCreatePerDiemPolicy();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ເບ້ຍລ້ຽງຕ່າງແຂວງ", to: "/app/performance/per-diem" },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">
            ເພີ່ມນະໂຍບາຍ per diem
          </h2>
        </div>
        <div className="rounded-xl border bg-card px-6">
          <PerDiemPolicyForm
            onSubmit={async (vals) => {
              try {
                const created = await createPolicy.mutateAsync(vals);
                nav({
                  to: "/app/performance/per-diem/$id/edit",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() => nav({ to: "/app/performance/per-diem" })}
            submitting={createPolicy.isPending}
          />
        </div>
      </Main>
    </>
  );
}
